import angular from 'angular';
import uiRouter from 'angular-ui-router';
import modal from 'angular-ui-bootstrap/src/modal';
import chargeCodeMappingComponent from './charge-code-mapping.component';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup'

let chargeCodeMappingModule = angular.module('chargeCodeMapping', [
  uiRouter,
  modal,
  datepickerPopup,
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider.state('quickbooks-charge-code-mapping', {
    parent: 'app',
    url: '/admin/integrations/quickbooks/charge-code-mapping',
    data: {
      pageHeader: true,
      pageTitle: 'Quickbooks Charge Code Mapping Capability',
      pageDesc: '',
      breadcrumbLink: 'quickbooks',
      breadcrumbText: 'Quickbooks Capabilities'
    },
    template: '<charge-code-mapping></charge-code-mapping>'
  })

})

.component('chargeCodeMapping', chargeCodeMappingComponent);

export default chargeCodeMappingModule;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/capabilities/charge-code-mapping/charge-code-mapping.js